module.exports = __webpack_public_path__ + "static/media/hover-panam-1250.2fa0e05c.png";